window.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations, obs) => {
    const yotpoElement = document.querySelector('.yotpo-star-rating-reviews-highly-rated-topics');
    if (yotpoElement) {
      yotpoElement.querySelectorAll('span').forEach(span => {
        span.style.fontFamily = "var(--font-body-family)";
        span.style.fontWeight = 400;
      })
      observer.disconnect();
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
